export default function printProductCategory(idCategoria) {
  const token = localStorage.getItem("token");
  printProductsCategory(token, idCategoria || '')
}
function printProductsCategory(token, idCategoria) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/products/print/report/all/a4/?auth=${token}&idCategoria=${idCategoria}`
  );
}
